import { render, staticRenderFns } from "./personOpen.vue?vue&type=template&id=1ec264da&scoped=true&"
import script from "./personOpen.vue?vue&type=script&lang=js&"
export * from "./personOpen.vue?vue&type=script&lang=js&"
import style0 from "./personOpen.vue?vue&type=style&index=0&id=1ec264da&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ec264da",
  null
  
)

export default component.exports